<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioFaltaMedica" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Médico</mat-label>
                            <mat-select value="Médico" formControlName="medico" name="medico" id="medico" required>
                                <mat-option *ngFor="let medico of listaMedicos" [value]="medico">
                                    {{medico.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioFaltaMedica.controls.medico.hasError('required')">
                                O campo Médico é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-5 col-md-5 col-sm-7 col-12"
                            style="text-align: center;">
                            <input matInput style="display: none">
                            <mat-radio-group aria-label="Select an option" formControlName="tipoDeFalta"
                                (change)="onTipoDeFaltaChange($event)" name="radioOpt1">
                                <mat-radio-button value="DI">Dia Inteiro</mat-radio-button>
                                <mat-radio-button value="M">Manhã</mat-radio-button>
                                <mat-radio-button value="T">Tarde</mat-radio-button>
                            </mat-radio-group>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-5 col-12">
                            <mat-label>Data da Falta</mat-label>
                            <input matInput [matDatepicker]="dataFaltaDP" formControlName="dataFalta" id="dataFalta"
                                name="dataFalta">
                            <mat-datepicker-toggle matSuffix [for]="dataFaltaDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataFaltaDP></mat-datepicker>

                            <mat-error *ngIf="formularioFaltaMedica.controls.dataFalta.hasError('required')">
                                O campo Data da Falta está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-12 col-12">
                            <mat-label>Horário da Falta</mat-label>
                            <mat-select formControlName="horaFalta" name="horaFalta">
                                <mat-option *ngFor="let horaFalta of listaHorarios" [value]="horaFalta.codigo">
                                    {{ horaFalta.descricao }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioFaltaMedica.controls.horaFalta.hasError('required')">
                                O campo Horário da Falta é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFaltaMedica.controls.horaFalta.hasError('invalid')">
                                O campo Horário da Falta está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Motivo da Falta</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="motivoFalta"
                                name="motivoFalta" id="motivoFalta" maxlength="120" upperCase></textarea>
                            <mat-error *ngIf="formularioFaltaMedica.controls.motivoFalta.hasError('required')">
                                O campo Motivo da Falta é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioFaltaMedica.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>